import './_bootstrap.js';
import 'fslightbox';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));
})();

// init Masonry
var grid = document.querySelector('.masonry');

var msnry = new Masonry( grid, {
  percentPosition: true
});

imagesLoaded( grid ).on( 'progress', function() {
  // layout Masonry after each image loads
  msnry.layout();
});